import { QueryHookOptions } from '@apollo/client';
import { useInfiniteQuery } from 'hooks/useInfiniteQuery';
import getPlatformAccountsQuery from '../../../../Fleets/hooks/managedPlatformAccountsQuery.graphql';

export const useManagedPlatformAccountsQuery = (
  options: QueryHookOptions<
    ManagedPlatformAccountsQuery,
    ManagedPlatformAccountsQueryVariables
  >,
) => {
  return useInfiniteQuery<
    ManagedPlatformAccountsQuery,
    ManagedPlatformAccountsQueryVariables
  >(getPlatformAccountsQuery, {
    fieldName: 'managedPlatformAccounts',
    ...options,
  });
};
